const page = {
  state: {
    isLoading: true
  },
  mutations: {
    SET_LOADING(state, loading) {
      state.isLoading = loading;
    }
  },
  actions: {}
};
export default page;
